var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"icon aufontAll h-icon-all-upload-o"}),_vm._v(_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }